// =============================================
// Centralized color palettes for KipiKid
// =============================================

export const adminColors = {
  primary: '#6366f1',
  primaryLight: '#eef2ff',
  secondary: '#14b8a6',
  secondaryLight: '#ccfbf1',
  success: '#22c55e',
  successLight: '#dcfce7',
  warning: '#f59e0b',
  warningLight: '#fef3c7',
  error: '#dc2626',
  text: '#1f2937',
  textLight: '#6b7280',
  border: '#e5e7eb',
  background: '#f9fafb',
  white: '#ffffff',
};

export const sysAdminColors = {
  primary: '#7c3aed',
  primaryLight: '#f5f3ff',
  secondary: '#14b8a6',
  secondaryLight: '#ccfbf1',
  success: '#22c55e',
  successLight: '#dcfce7',
  warning: '#f59e0b',
  warningLight: '#fef3c7',
  error: '#dc2626',
  text: '#1f2937',
  textLight: '#6b7280',
  border: '#e5e7eb',
  background: '#f9fafb',
  white: '#ffffff',
};

export const callCenterColors = {
  primary: '#0d9488',
  primaryLight: '#f0fdfa',
  danger: '#dc2626',
  dangerLight: '#fef2f2',
  dangerBorder: '#fca5a5',
  warning: '#f59e0b',
  warningLight: '#fef3c7',
  warningBorder: '#fcd34d',
  success: '#22c55e',
  successLight: '#dcfce7',
  info: '#3b82f6',
  infoLight: '#eff6ff',
  infoBorder: '#93c5fd',
  orange: '#ea580c',
  orangeLight: '#fff7ed',
  orangeBorder: '#fdba74',
  muted: '#6b7280',
  mutedLight: '#f3f4f6',
  text: '#1f2937',
  textLight: '#6b7280',
  border: '#e5e7eb',
  white: '#ffffff',
};

export const teacherColors = {
  primary: '#8b5cf6',
  primaryLight: '#ede9fe',
  primaryDark: '#7c3aed',
  text: '#1f2937',
  textLight: '#6b7280',
  border: '#e5e7eb',
  white: '#ffffff',
  green: '#22c55e',
  greenLight: '#dcfce7',
  yellow: '#f59e0b',
  yellowLight: '#fef3c7',
  red: '#ef4444',
  redLight: '#fee2e2',
  bg: '#f9fafb',
};

export const parentColors = {
  primary: '#f97316',
  primaryLight: '#ffedd5',
  secondary: '#14b8a6',
  secondaryLight: '#ccfbf1',
  success: '#22c55e',
  successLight: '#dcfce7',
  warning: '#f59e0b',
  warningLight: '#fef3c7',
  danger: '#ef4444',
  dangerLight: '#fee2e2',
  text: '#1f2937',
  textLight: '#6b7280',
  border: '#e5e7eb',
  weekend: '#fef3c7',
};

export const tabletColors = {
  primary: '#16a34a',
  primaryLight: '#dcfce7',
  text: '#1f2937',
  textLight: '#6b7280',
  border: '#e5e7eb',
  white: '#ffffff',
  green: '#22c55e',
  greenLight: '#dcfce7',
  red: '#ef4444',
  redLight: '#fee2e2',
  yellow: '#eab308',
  yellowLight: '#fef9c3',
};

export const calendarColors = {
  text: '#1f2937',
  textLight: '#6b7280',
  border: '#e5e7eb',
  background: '#f9fafb',
  white: '#ffffff',
};
